import { Navigate } from "react-router-dom";
import { useAuthListener } from "./firebaseHooks";
import NewSidebar from "../sidemenu/NewSideMenu";
import { useState } from "react";

const ProtectedRoute = ({ component: Component }: { component: any }) => {
  const { loggedIn, checkingStatus } = useAuthListener();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="bg-gray-50">
      <NewSidebar
        isOpen={sidebarOpen}
        toggleSidebar={() => setSidebarOpen((prev) => !prev)}
      />
      {
        checkingStatus ? (
          <div style={{ marginTop: window.innerHeight / 3 }}>
            {/* Loading Spinner or Placeholder */}
          </div>
        ) : loggedIn ? (
          <div className={`
            flex-1 
            transition-all duration-300 
            // you can tweak these widths as desired
            ${sidebarOpen ? "lg:ml-64" : "lg:ml-16"}
          `}>
            <Component />
          </div>
        ) : (
          <Navigate to="/login" />
        )
      }
    </div>
  );
};

export default ProtectedRoute;